import React, { useEffect, useRef, useState } from "react";
import {
	Button,
	CheckPicker,
	Checkbox,
	Modal,
	Radio,
	RadioGroup,
	useToaster,
	Notification,
	Tooltip,
	Whisper,
	SelectPicker,
} from "rsuite";
import "./opportunities.scss";
import SuppliersTable from "./suppliersTable";
import PeerBenchmarks from "./peerBenchmarks";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getOpportunitiesFilters,
	getOpportunitiesSuppliers,
	getSupplierPeerRebate,
	getNIARebateUpdateData,
	updateNIARebateData,
	getAllFiltersPerformance,
	getNIAPerformanceGraphData,
} from "../../queries/apiQueries";
import { FILTERDATA } from "../../utils";
import { appInsights } from "../router";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";
import { APPROACH } from "../../utils";
import NiaPerformance from "./niaPerformance";
import { niaMaskStatus } from "../constants";
import { COMMODITY } from "../../config/constants";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import { Segmented } from "antd";
import { Loader } from "../../components/common/Loader";
import PeerBenchmarksExp from "./peerbenchmarkexp";

const Opportunities = (props: any) => {
	const dispatch = useDispatch<any>();
	const toaster = useToaster();
	const approachSelected = useSelector(
		(state: any) => state.CommonReducer.approach
	);

	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};

	const message = (
		<Notification type={"info"} header={`Update`} closable>
			<p>Data Updated Successfully</p>
		</Notification>
	);

	const failedMessage = (
		<Notification type={"info"} header={`Update`} closable>
			<p>Something went wrong.</p>
		</Notification>
	);

	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);

	var isCleared = false;
	const [filtersLoading, setFiltersLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(false);
	const [isExpandedViewOpen, setIsExpandedViewOpen] = useState(false);

	const [vendorData, setVendorData] = useState<any>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [alert, setAlert] = useState(false);
	const [updateAlert, setUpdateAlert] = useState(false);
	const [tempVendorDetails, setTempVendorDetails] = useState<any>({});
	const [selectedVendor, setSelectedVendor] = useState<any>("");
	const [approach, setApproach] = useState(
		approachSelected ? approachSelected : "approach1"
	);
	const [rebateUpdate, setRebateUpdate] = useState(false);
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [spendConsolidated, setSpendConsolidated] = useState(1);
	const [commoditySupplier, setCommoditySupplier] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const [peerData, setPeerData] = useState({});
	const [performanceFilterData, setPerformanceFilterData] = useState<any>({});
	const [performanceGraphData, setPerformanceGraphData] = useState<any>({});
	const [updateRebateData, setUpdateRebateData] = useState([]);
	const [updateRebateDataBackup, setUpdateRebateDataBackup] = useState<any>(
		[]
	);
	const [updatedRebateDetails, setUpdatedRebateDetails] = useState<any>([]);
	const [page, setPage] = useState("benchmark");
	const [selectedMaskStatus, setSelectedMaskStatus] = useState(
		niaMaskStatus.length && niaMaskStatus[1].value
	);
	const [filterOptions, updateFilterOptions] = useState<any>({
		l1: new Array<{ l1: string }>(),
		supplier: new Array<{ vendor: string }>(),
	});

	const [selectedFilters, setSelectedFilters] = useState<any>([]);

	const [reset, setReset] = useState(false);

	const handleAlertClose = () => setAlert(false);
	const handleUpdateAlertClose = () => {
		setUpdateAlert(false);
		if (rebateUpdate) {
			getSuppliers();
			getPeerRebate();
			setRebateUpdate(false);
		}
	};

	const handleAlertConfirmClick = () => {
		setPeerData({});

		if (tempVendorDetails != selectedVendor) {
			vendorData.map((item: any, index: any) => {
				if (
					item.master_vendor_name ===
					selectedVendor.master_vendor_name
				) {
					vendorData[index].isReset = false;
				}
			});
			setSelectedVendor(tempVendorDetails);
			setSelectedFilters([]);
			setPerformanceFilterData({});
		}
		setAlert(false);
	};

	const validateNumbers = (e: any) => {
		return (e.target.value = e.target.value.replace(/[^\d]/g, ""));
	};

	const handleUpdateAlertConfirmClick = () => {
		if (updatedRebateDetails.length > 0) {
			updateRebate("update");
		}
		// setUpdateAlert(false);
	};

	const handleResetClick = () => {
		setUpdateRebateData(updateRebateDataBackup);
		updateRebateDataBackup.map((item: any) => {
			if (item.rebate_category == "Overall") {
				setSpendConsolidated(item.consolidatedFlag);
			}
		});
		setUpdatedRebateDetails([]);
		updateRebate("reset");
	};

	const handleRadioButtonChange = (value: any) => {
		setSpendConsolidated(value);

		let rData = JSON.parse(JSON.stringify(updateRebateData));
		let temp = JSON.parse(JSON.stringify(updatedRebateDetails));
		rData.map((item: any) => {
			if (
				temp.filter(
					(d1: any) => d1.rebate_category === item?.rebate_category
				).length > 0
			) {
				temp.map((d: any) => {
					d.consolidatedFlag = value;
				});
			} else {
				let newObject = {
					master_vendor_name: item?.master_vendor_name,
					rebate_category: item?.rebate_category,
					base: Number(item?.base) / 100,
					consolidatedFlag: value,
			        weight: Number(item?.weight),
					["0.00%"]: Number(item?.["0.00%"]) / 100,
					[`80.00%`]: Number(item?.["80.00%"]) / 100,
					["85.00%"]: Number(item?.["85.00%"]) / 100,
					["90.00%"]: Number(item?.["90.00%"]) / 100,
					["95.00%"]: Number(item?.["95.00%"]) / 100,
					["100.00%"]: Number(item?.["100.00%"]) / 100,
					["102.50%"]: Number(item?.["102.50%"]) / 100,
					["105.00%"]: Number(item?.["105.00%"]) / 100,
					["107.50%"]: Number(item?.["107.50%"]) / 100,
					["110.00%"]: Number(item?.["110.00%"]) / 100,
					["112.50%"]: Number(item?.["112.50%"]) / 100,
					["115.00%"]: Number(item?.["115.00%"]) / 100,
					["117.50%"]: Number(item?.["117.50%"]) / 100,
					["120.00%"]: Number(item?.["120.00%"]) / 100,
					["120+%"]: Number(item?.["120+%"]) / 100,
				};
				temp.push(newObject);
			}
		});

		setUpdatedRebateDetails(temp);
	};

	/* on changing the mask option */
	const maskStatusHandler = (e: any) => {
		setSelectedMaskStatus(e === null ? "All" : e);
	};

	console.log(selectedFilters, 321);
	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		let x: string = filter;
		if (x == "supplier") {
			if (value === "all") {
				if (filterOptions?.[x].length === selectedFilters?.[x].length) {
					setSelectedFilters({ ...selectedFilters, [x]: [] });
				} else {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				}
			} else {
				setSelectedFilters({ ...selectedFilters, [x]: [...value] });
			}
		} else {
			setSelectedFilters({ ...selectedFilters, [x]: [value] });
		}
		selectedFilters[x] = [value];
		if (filter === "l1") {
			updateFilterOptions({
				...filterOptions,
				supplier: performanceFilterData[value],
			});
			getPerformanceGraphData();
		}
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		console.log(selectedFilters);
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			// getFilters({ ...selectedFilters, l2: [], l3: [], l4: [], supplier: [] }, "l1");
		}
		if (filter === "supplier") {
			// getFilters({ ...selectedFilters }, "supplier");
		}
	};

	const handleClear = (filter: string) => {
		isCleared = true;
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
				l4: [],
				supplier: [],
			});
			// getFilters(
			//   { ...selectedFilters, l1: [], l2: [], l3: [], l4: [], supplier: [] },
			//   "l1"
			// );
		} else if (filter === "supplier") {
			setSelectedFilters({ ...selectedFilters, supplier: [] });
			// getFilters({ ...selectedFilters, supplier: [] }, "supplier");
		}
		if (filter == "supplier") {
		}
	};

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to NIA Peer Benchmark by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (selectedVendor !== "") {
			getPeerRebate();
			getPerformanceFilters();
		}
	}, [selectedVendor]);

	useEffect(() => {
		props.onApproachChange(approach);
		appInsights.trackPageView({
			name: `Calling supplier data on initial load of the page and change in approach`,
		});
		getSuppliers();
	}, [approach]);

	/*   useEffect(() => {
    props.onFilterChange(selectedFilters);
  }, [selectedFilters]) */

	/* Filters api call */
	/*   const getFilters = async (payload: any = {}, currentFilter: any = "all") => {
    setFiltersLoading(true);
    if (payload.supplier) {
      payload.vendor_name = payload.supplier;
      // delete payload.supplier;
    }
    let res = await dispatch(getOpportunitiesFilters(payload));
    if (res) {
      if (currentFilter === "district") {
        updateFilterOptions({
          ...filterOptions,
          l1: [...res.l1],
          l2: [...res.l2],
          l3: [...res.l3],
          supplier: [...res.suppliers],
        });
      } else if (currentFilter === "l1") {
        updateFilterOptions({
          ...filterOptions,
          l2: [...res.l2],
          l3: [...res.l3],
          supplier: [...res.suppliers],
        });
      } else if (currentFilter === "l2") {
        updateFilterOptions({
          ...filterOptions,
          l3: [...res.l3],
          supplier: [...res.suppliers],
        });
      } else if (currentFilter === "l3") {
        updateFilterOptions({ ...filterOptions, supplier: [...res.suppliers] });
      } else if (currentFilter === "supplier") {
        updateFilterOptions({ ...filterOptions });
      } else {
        updateFilterOptions({
          l1: res.l1,
          l2: res.l2,
          l3: res.l3,
          district: res.districts,
          supplier: res.suppliers
        });
      }
    }
    setIsLoading(false);
    setFiltersLoading(false);
  };
 */

	/* Supplier list (table Data) */
	const getSuppliers = async (payload: any = {},reset:boolean=false) => {
		setTableLoading(true);
		if (!rebateUpdate&&!reset) {
			setSelectedVendor("");
		}
		payload.approach = approach;
		if (payload.supplier) {
			payload.vendor_name = payload.supplier;
			// delete payload.supplier;
		}
		let res = await dispatch(getOpportunitiesSuppliers(payload));
		res.data = res.data.map((data: any) => {
			data.isReset = false;
			data.tempAdjustedBestRebate = data.adjustedBestRebate;
			return data;
		});
		setVendorData(res.data);
		setIsLoading(false);
		setTableLoading(false);
	};

	/* get peers data */
	const getPeerRebate = async () => {
		let payloadObject = {
			vendor_name: [selectedVendor.master_vendor_name],
			approach: approach,
		};
		setReset(selectedVendor.isReset);
		let res = await dispatch(getSupplierPeerRebate(payloadObject));
		setPeerData(res);
	};

	const getPerformanceFilters = async () => {
		let payloadObject = {
			master_vendor_name: [selectedVendor.master_vendor_name],
		};
		let res = await dispatch(getAllFiltersPerformance(payloadObject));
		let dummy: any = [];
		res?.l1?.map((item: any) => {
			dummy[`${item.L1}`] = [];
			Object.keys(item.Peers).map((p: any) => {
				dummy[`${item.L1}`].push({ vendor: p });
			});
		});
		setPerformanceFilterData(dummy);
		updateFilterOptions({
			l1: res.l1,
		});
	};

	console.log(performanceFilterData, 321);

	const getPerformanceGraphData = async () => {
		setTableLoading(true);
		let payloadObject = {
			vendor_name: [selectedVendor.master_vendor_name],
			approach: approach,
			l1: selectedFilters.l1,
		};
		let res = await dispatch(getNIAPerformanceGraphData(payloadObject));
		res?.data?.peer?.map((item: any) => {
			item.rebate_base_lastyear = item.rebate_base_lastyear * 100;
			item.gm = item.gm * 100;
			item.cagr = item.cagr * 100;
		});

		setSelectedFilters({
			...selectedFilters,
			supplier: res?.data?.selectedPeer,
		});

		setPerformanceGraphData(res.data);
		setTableLoading(false);
	};

	const getRebateUpdateData = async () => {
		let payloadObject = {
			master_vendor_name: [selectedVendor.master_vendor_name],
			approach: approach,
		};

		let res = await dispatch(getNIARebateUpdateData(payloadObject));

		res.data.map((item: any) => {
			if (item.rebate_category == "Overall") {
				setSpendConsolidated(item.consolidatedFlag);
			}
			item.base = (item.base * 100).toFixed(2);
			item["0.00%"] = (item["0.00%"] * 100).toFixed(2);
			item["80.00%"] = (item["80.00%"] * 100).toFixed(2);
			item["85.00%"] = (item["85.00%"] * 100).toFixed(2);
			item["90.00%"] = (item["90.00%"] * 100).toFixed(2);
			item["95.00%"] = (item["95.00%"] * 100).toFixed(2);
			item["100.00%"] = (item["100.00%"] * 100).toFixed(2);
			item["102.50%"] = (item["102.50%"] * 100).toFixed(2);
			item["105.00%"] = (item["105.00%"] * 100).toFixed(2);
			item["107.50%"] = (item["107.50%"] * 100).toFixed(2);
			item["110.00%"] = (item["110.00%"] * 100).toFixed(2);
			item["112.50%"] = (item["112.50%"] * 100).toFixed(2);
			item["115.00%"] = (item["115.00%"] * 100).toFixed(2);
			item["117.50%"] = (item["117.50%"] * 100).toFixed(2);
			item["120.00%"] = (item["120.00%"] * 100).toFixed(2);
			item["120+%"] = (item["120+%"] * 100).toFixed(2);
      		item.weight = (item.weight ).toFixed(2);

			item.rate = Number(item.base) + Number(item[item.rebateColName]);
		});

		if (res.data.length === 1) {
			let newObj: any = JSON.parse(JSON.stringify(res.data[0]));
			newObj.rebate_category = "OverallEdit";
			res.data.push(newObj);
		}

		setUpdateRebateData(res.data);

		setUpdateRebateDataBackup(JSON.parse(JSON.stringify(res.data)));
	};

	const updateRebate = async (action: any) => {
		let payloadObject = {};
		if (action == "update") {
			let newObj;
			newObj = updatedRebateDetails.filter(
				(d1: any) => d1.rebate_category != "OverallEdit"
			);

			payloadObject = {
				data: newObj,
				approach: approach,
				isReset: false,
			};
		} else if (action == "reset") {
			let resetData: any = [];
			updateRebateData.map((item: any) => {
				resetData.push({
					rebate_category: item.rebate_category,
					master_vendor_name: item.master_vendor_name,
				});
			});
			let newResetObj;
			newResetObj = resetData.filter(
				(d1: any) => d1.rebate_category != "OverallEdit"
			);
			payloadObject = {
				data: newResetObj,
				approach: approach,
				isReset: true,
			};
		}

		let res = await dispatch(updateNIARebateData(payloadObject));

		if (res.status == true) {
			setRebateUpdate(true);
			toaster.push(message, { placement: "topCenter" });
			if (action == "reset") {
				getRebateUpdateData();
			}
			setUpdatedRebateDetails([]);
		} else {
			toaster.push(failedMessage, { placement: "topCenter" });
		}
	};

	const updateRebateValue = (value: any, rebate: any, coloumn: any) => {

		let rData = JSON.parse(JSON.stringify(updateRebateData));
		let intialOverallObj:any = {};
			rData.map((item:any)=>{
			if(item.rebate_category == 'Overall'){
				intialOverallObj = item;
			}
		})
		if(coloumn == 'weight'){
			let totalWeight =0;
			rData.map((item:any)=>{
				if(item.rebate_category !== 'Overall'){
					if(item.rebate_category !== rebate.rebate_category){
						totalWeight = totalWeight +  Number(item.weight)
					}
					else{
						totalWeight = totalWeight + (Number(value))
					}
				}
			})
			if(totalWeight>100){
				return
			}
		}

		let temp = JSON.parse(JSON.stringify(updatedRebateDetails));
		let newRebate=0

		console.log(coloumn)

		rData.map((d:any)=>{
			if(d.rebate_category === rebate.rebate_category){
			d[coloumn] = (value);
			newRebate = newRebate + Number(value);
			if(coloumn === 'base'){
				d.rate = Number(value) + Number(d[d.rebateColName])
			} 
			else if(coloumn === d.rebateColName){
				d.rate = Number(value) + Number(d.base)
			}
			let newObject:any = {
				master_vendor_name: rebate?.master_vendor_name,
				rebate_category: rebate?.rebate_category,
				base: Number(rebate?.base)/100,
				weight: Number(rebate.weight),
				consolidatedFlag: rebate?.consolidatedFlag,
				['0.00%']: Number(rebate?.['0.00%'])/100,
				[`80.00%`]:   Number(rebate?.['80.00%'])/100,
				['85.00%']:   Number(rebate?.['85.00%'])/100,
				['90.00%']:   Number(rebate?.['90.00%'])/100,
				['95.00%']:   Number(rebate?.['95.00%'])/100,
				['100.00%']:  Number(rebate?.['100.00%'])/100,
				['102.50%']:  Number(rebate?.['102.50%'])/100,
				['105.00%']:  Number(rebate?.['105.00%'])/100,
				['107.50%']:  Number(rebate?.['107.50%'])/100,
				['110.00%']:  Number(rebate?.['110.00%'])/100,
				['112.50%']:  Number(rebate?.['112.50%'])/100,
				['115.00%']:  Number(rebate?.['115.00%'])/100,
				['117.50%']:  Number(rebate?.['117.50%'])/100,
				['120.00%']:  Number(rebate?.['120.00%'])/100,
				['120+%']:  Number(rebate?.['120+%'])/100,
				}
			newObject[coloumn]= coloumn =='weight' ? Number(value) : value/100;
			if(temp.filter((d1: any) => d1.rebate_category === rebate?.rebate_category).length > 0 ){
				temp.map((d2: any) => {
				if(d2.rebate_category === rebate?.rebate_category){
					d2[coloumn] = coloumn =='weight' ? Number(value) : value/100;
				}
				})
			}
			else{
				temp.push(newObject);
			}

			}
			else if(d.rebate_category != 'Overall'){
			newRebate = newRebate + Number(d[coloumn]);
			}
		})

		let newOverallRebate = 0;
		let newOverall:any = {};
		// let newOverallRebate = newRebate * rebate.weight / Number(rData[0].totalWeight);
		rData.map((item:any)=>{
			if(item.rebate_category !== 'Overall'){
			if(coloumn =='weight'){
				if(item.rebate_category !== rebate.rebate_category){
				newOverallRebate = newOverallRebate + (Number(item[coloumn]))
				}
				else{
				newOverallRebate = newOverallRebate + (Number(value))
				}

			} else{
				if(item.rebate_category !== rebate.rebate_category){
				newOverallRebate = newOverallRebate + ((Number(item[coloumn])/100) * Number(item.weight))
				}
				else{
				newOverallRebate = newOverallRebate + ((Number(value)/100) * Number(item.weight))
				}
			}
			}
		})
		newOverallRebate =( newOverallRebate); 


		//updating the overall rebate category object
		// if(temp.filter((d1: any) => d1.rebate_category === 'Overall' ).length > 0 ){
		//   temp.map((d2: any) => {
		//     if(d2.rebate_category === 'Overall'){
		//       d2[coloumn] = coloumn =='weight'? Number(newOverallRebate) : newOverallRebate/100;
		//       debugger
		//     }
		//   })
		// } else{

		//   let newObject:any={
		//     master_vendor_name: rebate?.master_vendor_name,
		//   rebate_category: 'Overall',
		//   base: Number(rebate?.base)/100,
		//   consolidatedFlag: spendConsolidated,
		//   ['0.00%']: rebate?.['0.00%']/100,
		//   [`80.00%`]:   Number(rebate?.['80.00%'])/100,
		//   ['85.00%']:   Number(rebate?.['85.00%'])/100,
		//   ['90.00%']:   Number(rebate?.['90.00%'])/100,
		//   ['95.00%']:   Number(rebate?.['95.00%'])/100,
		//   ['100.00%']:  Number(rebate?.['100.00%'])/100,
		//   ['102.50%']:  Number(rebate?.['102.50%'])/100,
		//   ['105.00%']:  Number(rebate?.['105.00%'])/100,
		//   ['107.50%']:  Number(rebate?.['107.50%'])/100,
		//   ['110.00%']:  Number(rebate?.['110.00%'])/100,
		//   ['112.50%']:  Number(rebate?.['112.50%'])/100,
		//   ['115.00%']:  Number(rebate?.['115.00%'])/100,
		//   ['117.50%']:  Number(rebate?.['117.50%'])/100,
		//   ['120.00%']:  Number(rebate?.['120.00%'])/100,
		//   ['120+%']:  Number(rebate?.['120+%'])/100,
		//   }
		//   newObject[coloumn]= coloumn =='weight'? Number(newOverallRebate) : newOverallRebate/100
		//   temp.push(newObject);
		// }

		// setUpdatedRebateDetails(temp);


		if(coloumn=='weight'){
			rData.map((d2: any) => {
			if(d2.rebate_category === 'Overall'){
				newOverall = {
				...d2,
				base: 0,
				["0.00%"]: 0,
				[`80.00%`]: 0,
				["85.00%"]: 0,
				["90.00%"]: 0,
				["95.00%"]: 0,
				["100.00%"]: 0,
				["102.50%"]: 0,
				["105.00%"]: 0,
				["107.50%"]: 0,
				["110.00%"]: 0,
				["112.50%"]: 0,
				["115.00%"]: 0,
				["117.50%"]: 0,
				["120.00%"]: 0,
				["120+%"]: 0,
				};
			}
			})
			rData.map((item:any)=>{
				if(item.rebate_category !== 'Overall'){
				
					if(item.rebate_category !== rebate.rebate_category){
					newOverall['base']= newOverall['base']+ ((Number(item[`base`])/100) * Number(item.weight))
					newOverall['0.00%']= newOverall['0.00%'] +((Number(item?.['0.00%'])/100) * Number(item.weight))
					newOverall[`80.00%`]= newOverall[`80.00%`]+( (Number(item?.['80.00%'])/100) * Number(item.weight))
					newOverall['85.00%']= newOverall['85.00%']+( (Number(item?.['85.00%'])/100) * Number(item.weight))
					newOverall['90.00%']= newOverall['90.00%']+ ( (Number(item?.['90.00%'])/100) * Number(item.weight))
					newOverall['95.00%']= newOverall['95.00%']+ (( Number(item?.['95.00%'])/100) * Number(item.weight))
					newOverall['100.00%']=newOverall['100.00%'] +(( Number(item?.['100.00%'])/100) * Number(item.weight))
					newOverall['102.50%']=newOverall['102.50%'] +(( Number(item?.['102.50%'])/100) * Number(item.weight))
					newOverall['105.00%']=newOverall['105.00%'] + ((Number(item?.['105.00%'])/100) * Number(item.weight))
					newOverall['107.50%']=newOverall['107.50%'] + ((Number(item?.['107.50%'])/100) * Number(item.weight))
					newOverall['110.00%']=newOverall['110.00%'] +(( Number(item?.['110.00%'])/100) * Number(item.weight))
					newOverall['112.50%']=newOverall['112.50%'] + ((Number(item?.['112.50%'])/100) * Number(item.weight))
					newOverall['115.00%']=newOverall['115.00%']  +((Number(item?.['115.00%'])/100) * Number(item.weight))
					newOverall['117.50%']=newOverall['117.50%']  +((Number(item?.['117.50%'])/100) * Number(item.weight))
					newOverall['120.00%']=newOverall['120.00%'] + ((Number(item?.['120.00%'])/100) * Number(item.weight))
					newOverall['120+%']=  newOverall['120+%']+ ((Number(item?.['120+%'])/100) * Number(item.weight))
					// newOverallRebate = newOverallRebate + ((Number(item[coloumn])/100) * Number(item.weight))
					}
					else{
					newOverall['base']= newOverall['base']+ ((Number(item[`base`])/100) * Number(value))
					newOverall['0.00%']= newOverall['0.00%'] +((Number(item?.['0.00%'])/100) * Number(value))
					newOverall[`80.00%`]= newOverall[`80.00%`]+( (Number(item?.['80.00%'])/100) * Number(value))
					newOverall['85.00%']= newOverall['85.00%']+( (Number(item?.['85.00%'])/100) * Number(value))
					newOverall['90.00%']= newOverall['90.00%']+ ( (Number(item?.['90.00%'])/100) * Number(value))
					newOverall['95.00%']= newOverall['95.00%']+ (( Number(item?.['95.00%'])/100) * Number(value))
					newOverall['100.00%']=newOverall['100.00%'] +(( Number(item?.['100.00%'])/100) * Number(value))
					newOverall['102.50%']=newOverall['102.50%'] +(( Number(item?.['102.50%'])/100) * Number(value))
					newOverall['105.00%']=newOverall['105.00%'] + ((Number(item?.['105.00%'])/100) * Number(value))
					newOverall['107.50%']=newOverall['107.50%'] + ((Number(item?.['107.50%'])/100) * Number(value))
					newOverall['110.00%']=newOverall['110.00%'] +(( Number(item?.['110.00%'])/100) * Number(value))
					newOverall['112.50%']=newOverall['112.50%'] + ((Number(item?.['112.50%'])/100) * Number(value))
					newOverall['115.00%']=newOverall['115.00%']  +((Number(item?.['115.00%'])/100) * Number(value))
					newOverall['117.50%']=newOverall['117.50%']  +((Number(item?.['117.50%'])/100) * Number(value))
					newOverall['120.00%']=newOverall['120.00%'] + ((Number(item?.['120.00%'])/100) * Number(value))
					newOverall['120+%']=  newOverall['120+%']+ ((Number(item?.['120+%'])/100) * Number(value))
					// newOverallRebate = newOverallRebate + ((Number(value)/100) * Number(item.weight))
					}
				
				}
			})
		}


		rData.map((d:any)=>{
			if(d.rebate_category == 'Overall'){
			d[coloumn] = newOverallRebate;
			if(coloumn =='weight'){
					d['base']= newOverall['base'];
					d['0.00%']= newOverall['0.00%'];
					d[`80.00%`]= newOverall[`80.00%`];
					d['85.00%']= newOverall['85.00%'];
					d['90.00%']= newOverall['90.00%'];
					d['95.00%']= newOverall['95.00%'];
					d['100.00%']=newOverall['100.00%'];
					d['102.50%']=newOverall['102.50%'];
					d['105.00%']=newOverall['105.00%'];
					d['107.50%']=newOverall['107.50%'];
					d['110.00%']=newOverall['110.00%'];
					d['112.50%']=newOverall['112.50%'];
					d['115.00%']=newOverall['115.00%'];
					d['117.50%']=newOverall['117.50%'];
					d['120.00%']=newOverall['120.00%'];
					d['120+%']=  newOverall['120+%'];
			}
			else{
				if(coloumn === 'base'){
				d.rate = Number(newOverallRebate) + Number(d[d.rebateColName])
				} 
				else if(coloumn === d.rebateColName){
				d.rate = Number(newOverallRebate) + Number(d.base)
				}
			}
			}
		})

		//updating the overall rebate category object
		if(temp.filter((d1: any) => d1.rebate_category === 'Overall' ).length > 0 ){
			temp.map((d2: any) => {
			if(d2.rebate_category === 'Overall'){
			
				if(coloumn =='weight'){
				d2['base'] = Number(newOverall?.base)/100;
				d2['0.00%'] = Number(newOverall?.['0.00%'])/100;
				d2[`80.00%`] =   Number(newOverall?.['80.00%'])/100;
				d2['85.00%'] =   Number(newOverall?.['85.00%'])/100;
				d2['90.00%'] =   Number(newOverall?.['90.00%'])/100;
				d2['95.00%'] =   Number(newOverall?.['95.00%'])/100;
				d2['100.00%'] =  Number(newOverall?.['100.00%'])/100;
				d2['102.50%'] =  Number(newOverall?.['102.50%'])/100;
				d2['105.00%'] =  Number(newOverall?.['105.00%'])/100;
				d2['107.50%'] =  Number(newOverall?.['107.50%'])/100;
				d2['110.00%'] =  Number(newOverall?.['110.00%'])/100;
				d2['112.50%'] =  Number(newOverall?.['112.50%'])/100;
				d2['115.00%'] =  Number(newOverall?.['115.00%'])/100;
				d2['117.50%'] =  Number(newOverall?.['117.50%'])/100;
				d2['120.00%'] =  Number(newOverall?.['120.00%'])/100;
				d2['120+%'] =  Number(newOverall?.['120+%'])/100;
				d2['weight'] = newOverallRebate
				} else{
				d2[coloumn] =  newOverallRebate/100;
				}
				
			}
			})
		} else{

			let newObject:any={
			master_vendor_name: rebate?.master_vendor_name,
			rebate_category: 'Overall',
			consolidatedFlag: spendConsolidated,
			weight: Number(intialOverallObj?.weight),
			base: coloumn=='weight'? Number(newOverall?.base):Number(rebate?.base)/100,
			['0.00%']: coloumn=='weight'? Number(newOverall?.['0.00%']) :rebate?.['0.00%']/100,
			[`80.00%`]:   coloumn=='weight'? Number(newOverall?.['80.00%']) :Number(rebate?.['80.00%'])/100,
			['85.00%']:   coloumn=='weight'? Number(newOverall?.['85.00%']) :Number(rebate?.['85.00%'])/100,
			['90.00%']:   coloumn=='weight'? Number(newOverall?.['90.00%']) :Number(rebate?.['90.00%'])/100,
			['95.00%']:   coloumn=='weight'? Number(newOverall?.['95.00%']) :Number(rebate?.['95.00%'])/100,
			['100.00%']:  coloumn=='weight'? Number(newOverall?.['100.00%']) :Number(rebate?.['100.00%'])/100,
			['102.50%']:  coloumn=='weight'? Number(newOverall?.['102.50%']) :Number(rebate?.['102.50%'])/100,
			['105.00%']:  coloumn=='weight'? Number(newOverall?.['105.00%']) :Number(rebate?.['105.00%'])/100,
			['107.50%']:  coloumn=='weight'? Number(newOverall?.['107.50%']) :Number(rebate?.['107.50%'])/100,
			['110.00%']:  coloumn=='weight'? Number(newOverall?.['110.00%']) :Number(rebate?.['110.00%'])/100,
			['112.50%']:  coloumn=='weight'? Number(newOverall?.['112.50%']) :Number(rebate?.['112.50%'])/100,
			['115.00%']:  coloumn=='weight'? Number(newOverall?.['115.00%']) :Number(rebate?.['115.00%'])/100,
			['117.50%']:  coloumn=='weight'? Number(newOverall?.['117.50%']) :Number(rebate?.['117.50%'])/100,
			['120.00%']:  coloumn=='weight'? Number(newOverall?.['120.00%']) :Number(rebate?.['120.00%'])/100,
			['120+%']:  coloumn=='weight'? Number(newOverall?.['120+%']) :Number(rebate?.['120+%'])/100,
			}
			newObject[coloumn]= coloumn =='weight'? Number(newOverallRebate) : newOverallRebate/100
			console.log('newOverall',newOverall, rData);

			temp.push(newObject);
		}

		setUpdatedRebateDetails(temp);



		console.log('****',rData,temp)

		setUpdateRebateData(rData);
	};

	useEffect(() => {
		console.log(
			filterOptions?.l1?.length === 1,
			filterOptions?.l1,
			filterOptions?.l1[0]?.L1 === "Electrical",
			COMMODITY?.includes(selectedVendor?.master_vendor_name)
		);
		if (
			filterOptions?.l1?.length === 1 &&
			filterOptions?.l1[0]?.L1 === "ELECTRICAL"
		) {
			if (COMMODITY?.includes(selectedVendor?.master_vendor_name)) {
				setCommoditySupplier(true);
			}
		} else if (
			selectedFilters?.l1 &&
			selectedFilters?.l1[0] === "ELECTRICAL"
		) {
			setCommoditySupplier(
				COMMODITY?.includes(selectedVendor?.master_vendor_name)
					? true
					: false
			);
		} else {
			setCommoditySupplier(false);
		}
	}, [selectedVendor, selectedFilters?.l1, filterOptions?.l1]);

	const handleToggleChange = (event: { target: { checked: any } }) => {
		setPage(event.target.checked ? "performance" : "benchmark");
	};

	return isLoading ? (
		<Loader />
	) : (
		<>
			<Modal
				backdrop={true}
				role="alertdialog"
				open={alert}
				onClose={handleAlertClose}
				size="xs"
			>
				<Modal.Body>
					You have some unsaved changes. Are you sure, you want to
					continue without saving?
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={handleAlertConfirmClick}
						className="modal-yes-btn"
					>
						Yes, Continue
					</Button>
					<Button
						onClick={handleAlertClose}
						className="modal-close-btn"
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
			<Modal
				backdrop={true}
				className="update-modal opportunity-modal"
				backdropClassName="update-backdrop"
				role="alertdialog"
				open={updateAlert}
				onClose={handleUpdateAlertClose}
				size="xs"
			>
				<Modal.Header onClose={handleAlertClose}>
					<div className="flex">
						<div className="text-center text-[2.5vh] w-full mb-[3vh]">
							Update Rebate Structure
						</div>
						{/* <Button
							onClick={handleUpdateAlertClose}
							style={{ background: "#941c14" }}
							className="modal-close-btn h-[4vh]"
						>
							Close
						</Button> */}
					</div>
				</Modal.Header>
				<Modal.Body>
					<table className="common-table-ui">
						<thead>
							<tr>
								<th>Vendor</th>
								<th>Rebate Category</th>
								<th>Weight</th>
								<th>Base Rebate</th>
								<th>0%</th>
								<th>80%</th>
								<th>85%</th>
								<th>90%</th>
								<th>95%</th>
								<th>100%</th>
								<th>102.5%</th>
								<th>105%</th>
								<th>107.5%</th>
								<th>110%</th>
								<th>112.5%</th>
								<th>115%</th>
								<th>117.5%</th>
								<th>120%</th>
								<th>120+%</th>
								<th>Rate</th>
							</tr>
						</thead>
						<tbody>
							{updateRebateData.length > 0 &&
								updateRebateData?.map((d: any, index: any) => {
									if (d.rebate_category === "Overall") {
										return (
											<tr key={index}>
												{
													<td
														rowSpan={
															updateRebateData.length
														}
													>
														{
															selectedVendor?.master_vendor_name
														}
													</td>
												}
												<td
													style={{
														textAlign: "center",
													}}
												>
													{d.rebate_category}
												</td>
												<td style={{ textAlign: "center" }}>
													{parseFloat(d.weight)?.toFixed(2)}%
												</td>
												<td>
													{parseFloat(
														d.base
													)?.toFixed(2)}
													%
												</td>

												<td>
													<div className="flex">
														{d.rebateColName ==
															"0.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["0.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"80.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["80.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"85.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["85.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"90.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["90.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"95.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["95.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>

												<td>
													<div className="flex">
														{d.rebateColName ==
															"100.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["100.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"102.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["102.50%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"105.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["105.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"107.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["107.50%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"110.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["110.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"112.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["112.50%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"115.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["115.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"117.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["117.50%"]
														)?.toFixed(2)}
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"120.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["120.00%"]
														)?.toFixed(2)}
														%
													</div>
												</td>

												<td>
													<div className="flex">
														{d.rebateColName ==
															"120+%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														{parseFloat(
															d["120+%"]
														)?.toFixed(2)}
														%
													</div>
												</td>

												<td>
													{Number(d?.rate)?.toFixed(
														2
													)}
													%
												</td>
											</tr>
										);
									}
								})}

							{updateRebateData.length > 0 &&
								updateRebateData?.map((d: any, index: any) => {
									if (d.rebate_category !== "Overall") {
										return (
											<tr key={index}>
												<td
													style={{
														textAlign: "center",
													}}
												>
													{d.rebate_category ==
													"OverallEdit"
														? "Overall"
														: d.rebate_category}
												</td>
												<td>
													<div className="flex">
													{d.rebate_category === "Overall" ? (
														d.weight
													) : (
														<input
														type="text"
														className="adjustedPriceInput"
														value={d.weight}
														onChange={(e) => {
															updateRebateValue(e.target.value, d, "weight");

														}}
														/>
													)}%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebate_category ===
														"Overall" ? (
															d.base
														) : (
															<input
																type="text"
																className="adjustedPriceInput "
																value={d.base}
																onChange={(
																	e
																) => {
																	updateRebateValue(
																		e.target
																			.value,
																		d,
																		"base"
																	);
																}}
															/>
														)}{" "}
														%
													</div>
												</td>

												<td>
													<div className="flex">
														{d.rebateColName ==
															"0.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["0.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"0.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"80.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["80.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"80.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"85.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["85.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"85.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"90.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["90.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"90.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"95.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["95.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"95.00%"
																);
															}}
														/>
														%
													</div>
												</td>

												<td>
													<div className="flex">
														{d.rebateColName ==
															"100.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["100.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"100.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"102.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["102.50%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"102.50%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"105.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["105.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"105.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"107.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["107.50%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"107.50%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"110.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput"
															value={d["110.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"110.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"112.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["112.50%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"112.50%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"115.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["115.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"115.00%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"117.50%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["117.50%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"117.50%"
																);
															}}
														/>
														%
													</div>
												</td>
												<td>
													<div className="flex">
														{d.rebateColName ==
															"120.00%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput"
															value={d["120.00%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"120.00%"
																);
															}}
														/>
														%
													</div>
												</td>

												<td>
													<div className="flex">
														{d.rebateColName ==
															"120+%" && (
															<div
																style={{
																	width: 0,
																	height: 0,
																	borderLeft:
																		"1vh solid transparent",
																	borderRight:
																		"1vh solid transparent",
																	borderTop:
																		"1.5vh solid #ffd500",
																	margin: ".5vh",
																}}
															/>
														)}
														<input
															type="text"
															className="adjustedPriceInput "
															value={d["120+%"]}
															onChange={(e) => {
																updateRebateValue(
																	e.target
																		.value,
																	d,
																	"120+%"
																);
															}}
														/>
														%
													</div>
												</td>

												<td className="whitespace-nowrap">
													{Number(d?.rate)?.toFixed(
														2
													)}
													%
												</td>
											</tr>
										);
									}
								})}
						</tbody>
					</table>

					<div className="flex mt-[2vh] items-center justify-center gap-x-[4vh]">
						<span>
							Spend Consolidated for NIA subs and Graybar?
						</span>
						<RadioGroup
							name="radio-group-inline"
							inline
							defaultValue={spendConsolidated}
							value={spendConsolidated}
							onChange={(value: any) => {
								handleRadioButtonChange(value);
							}}
						>
							<Radio value={1} color="green" className="mr-[4vh]">
								Yes
							</Radio>
							<Radio value={0} color="green">
								No
							</Radio>
						</RadioGroup>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={handleUpdateAlertConfirmClick}
						className="modal-yes-btn"
					>
						Submit Changes
					</Button>
					<Button
						onClick={handleResetClick}
						className="modal-close-btn"
					>
						Reset
					</Button>
				</Modal.Footer>
			</Modal>
			<div className="opportunities-dashboard-container w-full ">
				<Modal
					open={isExpandedViewOpen}
					onClose={() => setIsExpandedViewOpen(false)}
					size="lg"
					backdrop={true}
				>
					<Modal.Header>
						<Modal.Title>Expanded View</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{/* Render the detailed-data-container content here */}
						<div className="detailed-data-container p-[1vw]]">
							{selectedVendor === "" ? (
								<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
									Please select the Supplier to see its Peer
									benchmarks
								</div>
							) : page == "benchmark" ? (
								Object.keys(peerData).length > 0 ? (
									<PeerBenchmarksExp
										isVisible={isVisible}
										peerDatas={peerData}
										updateBestPeerEffectiveRebate={(
											rebate: any
										) => {
											let vendor: any = vendorData;
											vendor = vendor.map((d: any) => {
												if (
													d.master_vendor_name ==
													selectedVendor.master_vendor_name
												) {
													d.tempAdjustedBestRebate =
														rebate / 100;
												}
												return d;
											});
											setVendorData(vendor);
										}}
										isResetAvailable={reset}
										updateReset={(
											flag: boolean,
											trigger: string,
											rebate: number = 0
										) => {
											setReset(flag);
											let vendor: any = vendorData;
											vendor = vendor.map((d: any) => {
												if (
													d.master_vendor_name ==
													selectedVendor.master_vendor_name
												) {
													d.isReset = flag;
													if (
														!flag &&
														trigger == "reset"
													) {
														d.tempAdjustedBestRebate =
															d.adjustedBestRebate;
													} else if (
														!flag &&
														trigger == "save"
													) {
														d.tempAdjustedBestRebate =
															rebate;
														d.adjustedBestRebate =
															rebate;
													}
												}
												return d;
											});
											setVendorData(vendor);
											if (!flag) {
												getPeerRebate();
											}
										}}
									/>
								) : (
									<Loader />
								)
							) : page == "performance" &&
							  selectedFilters?.l1?.length > 0 &&
							  !commoditySupplier ? (
								Object.keys(performanceGraphData).length > 0 ? (
									<NiaPerformance
										selectedVendor={selectedVendor}
										supplier={selectedFilters?.supplier}
										selectedMaskStatus={selectedMaskStatus}
										performanceGraphData={
											performanceGraphData
										}
									/>
								) : (
									<Loader />
								)
							) : (
								<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
									<h1>
										{commoditySupplier
											? filterOptions?.l1?.length > 1
												? "Please select different L1"
												: "Please select a non-commodity supplier"
											: "Please select the L1 to see NIA Performance"}
									</h1>
								</div>
							)}
						</div>
					</Modal.Body>
				</Modal>

				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					isIconVisible={page === "performance"?true:false}
					topContent={
						<>
							<div className="flex justify-between items-center w-full">
								<div className="text-left pageline">
									<span className="pagelinestart">NIA</span>{" "}
									<span className="pagelineslash">/</span>{" "}
									<span className="pagelinesub">
										NIA Peer Benchmark
									</span>
								</div>
							</div>

							<div className="execution-level-wrapper">
								<div className="execution-level-title">
									View By
								</div>
								<Segmented
									options={[
										{
											label: "NIA Benchmark",
											value: "benchmark",
										},
										{
											label: "NIA Performance",
											value: "performance",
										},
									]}
									value={page}
									onChange={(value) => setPage(value)}
								/>
							</div>
						</>
					}
					bottomContent={
						<>
							{page === "performance" && (
								<>
									<div className="sub-heading-text font-bold flex flex-col items-start">
										<span className="filterHead ">L1</span>
										<SelectPicker
											data={
												filterOptions?.l1?.length
													? filterOptions?.l1
													: []
											}
											labelKey="L1"
											valueKey="L1"
											value={
												selectedFilters?.l1
													? selectedFilters?.l1[0]
													: []
											}
											cleanable={false}
											onClose={() => handleClose("l1")}
											onChange={(value) =>
												handleFilterUpdate(value, "l1")
											}
										/>
									</div>
									<div className="sub-heading-text font-bold flex flex-col items-start">
										<span className="filterHead ">
											Supplier
										</span>
										<CheckPicker
											data={
												filterOptions["supplier"]
													?.length
													? filterOptions["supplier"]
													: []
											}
											placeholder="All"
											labelKey="vendor"
											valueKey="vendor"
											virtualized
											value={
												selectedFilters?.supplier
													?.length
													? selectedFilters?.supplier
													: []
											}
											onClose={() =>
												handleClose("supplier")
											}
											onChange={(value) =>
												handleFilterUpdate(
													value,
													"supplier"
												)
											}
											onClean={() =>
												handleClear("supplier")
											}
											renderExtraFooter={() => (
												<div style={footerStyles}>
													<Checkbox
														indeterminate={
															selectedFilters
																?.supplier
																?.length > 0 &&
															selectedFilters
																?.supplier
																?.length <
																filterOptions
																	?.supplier
																	?.length
														}
														checked={
															selectedFilters
																?.supplier
																?.length ===
															filterOptions
																?.supplier
																?.length
														}
														onChange={(value) =>
															handleFilterUpdate(
																"all",
																"supplier"
															)
														}
													>
														Check all
													</Checkbox>
												</div>
											)}
										/>
									</div>
									<div className="sub-heading-text font-bold flex flex-col items-start">
										<span className="filterHead ">
											Mask(Y/N)
										</span>
										<SelectPicker
											data={
												niaMaskStatus.length
													? niaMaskStatus
													: []
											}
											placeholder="All"
											value={selectedMaskStatus}
											
											defaultValue={
												niaMaskStatus.length
													? niaMaskStatus[1].value
													: 1
											}
											onChange={maskStatusHandler}
											cleanable={false}
										/>
									</div>
								</>
							)}
						</>
					}
				></MainHeader>
				<MainContent isVisible={isVisible} fullHeight={true}>
					<div className="chart-flex h-[100%]">
						<div className="suppliers">
							{tableLoading ? (
								<Loader />
							) : (
								<SuppliersTable
									data={vendorData}
									updateVendor={(vendor: any) => {
										if (reset) {
											setAlert(true);
											setTempVendorDetails(vendor);
										} else {
											setPeerData({});
											if (vendor != selectedVendor) {
												setSelectedVendor(vendor);
												setSelectedFilters([]);
												setPerformanceFilterData({});
											}
										}
									}}
									selectedVendor={selectedVendor}
									showUpdateButton={
										selectedVendor !== "" &&
										page === "benchmark"
									}
									onUpdateRebate={() => {
										setUpdateAlert(true);
										getRebateUpdateData();
									}}
									approach={approach}
									onApproachChange={setApproach}
									approachOptions={[
										{
											value: "approach1",
											label: "Approach 1",
											tooltip:
												"Prorates the spend by annualizing the average monthly spend of the completed months.",
										},
										{
											value: "approach2",
											label: "Approach 2",
											tooltip:
												"Assumes the same monthly spend for the remaining months as observed in the corresponding months of the previous year.",
										},
										{
											value: "approach3",
											label: "Approach 3",
											tooltip:
												"Projects the annual spend by applying the growth rate of the YTD spend to the average spend of the remaining months from the previous year.",
										},
									]}
								/>
							)}
						</div>
						<div className="detailed-data-container">
							{selectedVendor === "" ? (
								<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
									Please select the Supplier to see its Peer
									benchmarks
								</div>
							) : page == "benchmark" ? (
								Object.keys(peerData).length > 0 ? (
									<PeerBenchmarks
										isVisible={isVisible}
										peerDatas={peerData}
										onExpandView={() =>
											setIsExpandedViewOpen(true)
										}
										updateBestPeerEffectiveRebate={(
											rebate: any
										) => {
											let vendor: any = vendorData;
											vendor = vendor.map((d: any) => {
												if (
													d.master_vendor_name ==
													selectedVendor.master_vendor_name
												) {
													d.tempAdjustedBestRebate =
														rebate / 100;
												}
												return d;
											});
											setVendorData(vendor);
										}}
										isResetAvailable={reset}
										updateReset={(
											flag: boolean,
											trigger: string,
											rebate: number = 0
										) => {
											setReset(flag);
											let vendor: any = vendorData;
											vendor = vendor.map((d: any) => {
												if (
													d.master_vendor_name ==
													selectedVendor.master_vendor_name
												) {
													d.isReset = flag;
													if (
														!flag &&
														trigger == "reset"
													) {
														d.tempAdjustedBestRebate =
															d.adjustedBestRebate;
													} else if (
														!flag &&
														trigger == "save"
													) {
														d.tempAdjustedBestRebate =
															rebate;
														d.adjustedBestRebate =
															rebate;
													}
												}
												return d;
											});
											setVendorData(vendor);
											if (!flag) {
												getPeerRebate();
												getSuppliers({},true)
											}
										}}
									/>
								) : (
									<Loader />
								)
							) : page == "performance" &&
							  selectedFilters?.l1?.length > 0 &&
							  !commoditySupplier ? (
								Object.keys(performanceGraphData).length > 0 ? (
									<NiaPerformance
										selectedVendor={selectedVendor}
										supplier={selectedFilters?.supplier}
										selectedMaskStatus={selectedMaskStatus}
										performanceGraphData={
											performanceGraphData
										}
									/>
								) : (
									<Loader />
								)
							) : (
								<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
									<h1>
										{
										commoditySupplier
										? 

											filterOptions?.l1?.length > 1
												? "Please select different L1"
												: "Please select a non-commodity supplier"


											: "Please select the L1 to see NIA Performance"}
									</h1>
								</div>
							)}
						</div>
					</div>
				</MainContent>
			</div>
		</>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	onApproachChange: (data: any) => dispatch({ type: APPROACH, data: data }),
});

export default connect(null, mapDispatchToProps)(Opportunities);
